var React = require('react');

function PlayInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 2.67949L31 20L1 37.3205L1 2.67949Z","stroke":"white","strokeWidth":"2","vectorEffect":"non-scaling-stroke"}));
}

PlayInline.defaultProps = {"width":"33","height":"40","viewBox":"0 0 33 40","fill":"none"};

module.exports = PlayInline;

PlayInline.default = PlayInline;
